import { systemEngineEnvironment } from "services/environment/systemEngine";

export const updateUserServiceAccount = async (
  userName: string,
  serviceAccountName: string | null,
  accountName?: string
) => {
  const sql = serviceAccountName
    ? `ALTER USER "${userName}" SET SERVICE_ACCOUNT = "${serviceAccountName}"`
    : `ALTER USER "${userName}" SET SERVICE_ACCOUNT = DEFAULT LOGIN = DEFAULT;`;
  await systemEngineEnvironment.execute(sql, { accountName });
};
